import { Page } from "@core/components/layout/page";
import {
  PageNavbarItem,
  PageNavbar,
} from "@core/components/layout/page-navbar";
import {
  createFileRoute,
  Outlet,
  useLocation,
  useMatchRoute,
} from "@tanstack/react-router";
import { useEffect, useRef } from "react";
import { cn } from "web-design-system";

export const Route = createFileRoute("/(auth)/_headed/resources/_layout")({
  component: RouteComponent,
});

function RouteComponent() {
  const scrollContainerRef = useRef<HTMLDivElement | null>(null);
  const location = useLocation();

  useEffect(() => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollTop = 0;
    }
  }, [location.pathname, location.searchStr]);

  const matchRoute = useMatchRoute();

  const contentClassName = cn({
    "overflow-hidden": Boolean(
      matchRoute({ to: "/resources/marketing", fuzzy: true }) ||
      matchRoute({ to: "/resources/webinars", fuzzy: true })
    ),
  });

  return (
    <Page>
      <Page.Content ref={scrollContainerRef} className={cn(contentClassName)}>
        <PageNavbar className="sticky top-0 z-2 bg-background shrink-0">
          <PageNavbarItem to="/resources/featured">Featured</PageNavbarItem>
          <PageNavbarItem to="/resources/marketing">Marketing</PageNavbarItem>
          <PageNavbarItem to="/resources/webinars">Webinars</PageNavbarItem>
          <PageNavbarItem to="/resources/knowledge">Knowledge</PageNavbarItem>
        </PageNavbar>
        <Outlet />
      </Page.Content>
    </Page>
  );
}
